import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getIdData } from '../../lib/studentinfo'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { GlobalStudentTask } from './GlobalStudentTask'
import { GlobalCheckList } from './GlobalCheckList'
import { Tasks } from './Tasks'

const InstructorStudentTaskList = () => {
	const { studentId } = useParams()
	const { user } = useAuth()

	const [isStudent12, setIsStudent12] = useState(false)
	const [loading, setLoading] = useState(true)

	// Detect if this is being viewed by instructor or student
	const isInstructorView = user?.role === 'Instructor'

	// Use studentId from params if instructor, otherwise use logged-in user's id
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	const getData = async () => {
		try {
			setLoading(true)
			const info = await getIdData(effectiveStudentId)
			if (info && info.length > 0) {
				if (info[0].role === 'Student12') {
					setIsStudent12(true)
				}
			}
		} catch (error) {
			console.error('Error fetching student data:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (effectiveStudentId) {
			getData()
		}
	}, [effectiveStudentId])

	if (loading) {
		return (
			<div className="container-fluid">
				<div className="text-center">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-2">Loading student data...</p>
				</div>
			</div>
		)
	}

	return (
		<StudentTopMenuLayout activeMenu="Agenda" pageName="Agenda">
			<GlobalStudentTask studentId={effectiveStudentId} type={226} isStudent={!isInstructorView} />
			{isStudent12 && <GlobalCheckList slug={effectiveStudentId} isStudent={!isInstructorView} />}
			<div className="settings-widget profile-details">
				<div className="settings-inner-blk p-0">
					<Tasks slug={effectiveStudentId} isStudentView={!isInstructorView} />
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { InstructorStudentTaskList }
